var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    {
      class: { "table-active": _vm.file.select },
      on: { click: _vm.toggleSelect }
    },
    [
      _c("td", { staticClass: "text-center" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.file.select,
              expression: "file.select"
            }
          ],
          attrs: { type: "checkbox" },
          domProps: {
            checked: Array.isArray(_vm.file.select)
              ? _vm._i(_vm.file.select, null) > -1
              : _vm.file.select
          },
          on: {
            click: function($event) {
              $event.stopPropagation()
            },
            __c: function($event) {
              var $$a = _vm.file.select,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.file.select = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.file.select = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.file.select = $$c
              }
            }
          }
        })
      ]),
      _c("td", [_vm._v(_vm._s(_vm.file.id))]),
      _c("td", [
        _c("div", { staticClass: "d-flex" }, [
          _c(
            "a",
            {
              attrs: { href: _vm.file.link, target: "_new" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [_vm._v("\n        " + _vm._s(_vm.file.name) + "\n      ")]
          ),
          _c("span", { staticClass: "thumb ml-auto" }, [
            _vm.file.image_info
              ? _c("img", { attrs: { height: "24", src: _vm.file.link } })
              : _vm._e()
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34486478", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34486478","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./components/file-row.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-34486478","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./components/file-row.vue
// module chunks = 16